import { useQuery , keepPreviousData } from '@tanstack/react-query';

import { DEFAULT_PAGE_INDEX, DEFAULT_PER_PAGE_GET_ALL } from 'src/constants/pagination';
import { CATEGORY } from 'src/constants/services';
import { fetchApiV3Publishing } from 'src/utils/fetch-api';

export const categoriesQueryKey = 'categories';

const useCategories = (type: string) => {
	const { data, ...restAttributes } = useQuery({
		queryKey: [categoriesQueryKey, type],
		queryFn: () => {
			return fetchApiV3Publishing({
				url: CATEGORY.service,
				payload: {
					type,
					page: DEFAULT_PAGE_INDEX,
					per_page: DEFAULT_PER_PAGE_GET_ALL,
				},
			});
		},
			placeholderData: keepPreviousData,
			refetchOnMount: false,
			refetchOnWindowFocus: false,
			enabled: true,
		},
	);

	return {
		data: data?.data?.records,
		meta: data?.meta,
		...restAttributes,
	};
};

export default useCategories;
